export function getRandomEmoji() {
  const emojis = [
      "😀", "😂", "😍", "😎", "😭",
      "😜", "😔", "😃", "😊", "😏",
      "😢", "😠", "😪", "🥳", "🤔",
      "🤯", "😅", "😩", "😱", "🥰",
      "🤗", "😴", "🤔", "🤓", "🙌",
      "👏", "👍", "👎", "🤷‍♂️", "🤷‍♀️",
      "💪", "💔", "🎉", "💯", "🔥",
      "⭐", "🌟", "✨", "🌈", "🌹",
      "🌻", "🍎", "🍕", "🍔", "🌍",
      "🌎", "🌏", "🌌", "🚀", "🎵"
  ];

  const randomIndex = Math.floor(Math.random() * emojis.length);
  return emojis[randomIndex];
}

export function getRandomName() {
  const names = [
      // Fictional Characters
      "Harry Potter",
      "Sherlock Holmes",
      "Frodo Baggins",
      "Lara Croft",
      "Darth Vader",
      "Hermione Granger",
      "Luke Skywalker",
      "Wolverine",
      "Katniss Everdeen",
      "Batman",
      "Spiderman",
      "Wonder Woman",
      "Iron Man",
      "Gandalf",
      "James Bond",
      "Elsa",
      "Rick Sanchez",
      "Mickey Mouse",
      "Indiana Jones",
      "Yoda",

      // Global Celebrities
      "Beyoncé",
      "Leonardo DiCaprio",
      "Taylor Swift",
      "Oprah Winfrey",
      "Elon Musk",
      "Dwayne 'The Rock' Johnson",
      "Scarlett Johansson",
      "Tom Hanks",
      "Angelina Jolie",
      "Brad Pitt",
      "Ariana Grande",
      "Jennifer Lawrence",
      "Rihanna",
      "Will Smith",
      "Keanu Reeves",
      "Johnny Depp",
      "Meryl Streep",
      "Chris Hemsworth",
      "Emma Watson",
      "Robert Downey Jr.",

      // Indian Personalities
      "Mahatma Gandhi",
      "Sachin Tendulkar",
      "Amitabh Bachchan",
      "Lata Mangeshkar",
      "Virat Kohli",
      "Priyanka Chopra",
      "Shah Rukh Khan",
      "A. R. Rahman",
      "Sushmita Sen",
      "Ratan Tata",
      "M. S. Dhoni",
      "Narendra Modi",
      "Deepika Padukone",
      "Ranveer Singh",
      "Aishwarya Rai",
      "Sania Mirza",
      "Anushka Sharma",
      "Rajinikanth",
      "Sundar Pichai",
      "Mukesh Ambani",

      // Football Players
      "Lionel Messi",
      "Cristiano Ronaldo",
      "Neymar Jr.",
      "Kylian Mbappé",
      "Mohamed Salah",
      "Robert Lewandowski",
      "Kevin De Bruyne",
      "Virgil van Dijk",
      "Sergio Ramos",
      "Gareth Bale",
      "Luka Modrić",
      "Paul Pogba",
      "Harry Kane",
      "Karim Benzema",
      "Manuel Neuer",
      "Sadio Mané",
      "Eden Hazard",
      "Son Heung-min",
      "Zlatan Ibrahimović",
      "Xavi Hernández"
  ];

  const randomIndex = Math.floor(Math.random() * names.length);
  return names[randomIndex];
}


export function getRandomString() {
  const messages = [
      // Greetings
      "Hello!",
      "Hi there!",
      "Greetings!",
      "Good day!",
      "Hey!",

      // Farewells
      "Goodbye!",
      "See you later!",
      "Take care!",
      "Farewell!",
      "Catch you later!",

      // Compliments
      "You're amazing!",
      "You did a great job!",
      "You're so talented!",
      "You have a great sense of humor!",
      "You're really kind!",

      // Motivational Quotes
      "Keep pushing forward!",
      "Believe in yourself!",
      "You can achieve anything!",
      "Stay positive and strong!",
      "Never give up!",

      // Days of the Week
      "Monday: A fresh start!",
      "Tuesday: Keep going!",
      "Wednesday: Halfway there!",
      "Thursday: Almost there!",
      "Friday: The weekend is near!",
      "Saturday: Relax and enjoy!",
      "Sunday: Recharge for the week ahead!",

      // Months
      "January: New beginnings!",
      "February: Spread love!",
      "March: Spring is coming!",
      "April: Time to bloom!",
      "May: Flowers and sunshine!",
      "June: Summer vibes!",
      "July: Fun in the sun!",
      "August: Soak up the sun!",
      "September: Back to school!",
      "October: Embrace the autumn!",
      "November: Give thanks!",
      "December: Festive joy!",

      // Famous TV Series
      "Breaking Bad: Say my name.",
      "Game of Thrones: Winter is coming.",
      "Friends: How you doin'?",
      "The Office: That's what she said.",
      "Stranger Things: Friends don't lie.",

      // Famous Movies
      "The Godfather: I'm gonna make him an offer he can't refuse.",
      "Forrest Gump: Life is like a box of chocolates.",
      "Star Wars: May the Force be with you.",
      "The Matrix: There is no spoon.",
      "Titanic: I'm the king of the world!",

      // Famous Personalities
      "Albert Einstein: Imagination is more important than knowledge.",
      "Mahatma Gandhi: Be the change you wish to see in the world.",
      "Nelson Mandela: It always seems impossible until it's done.",
      "Marie Curie: Nothing in life is to be feared; it is only to be understood.",
      "Steve Jobs: Stay hungry, stay foolish."
  ];

  const randomIndex = Math.floor(Math.random() * messages.length);
  return messages[randomIndex];
}


// export function makeRandomMessage(length) {
//   let result = "";
//   const characters =
//     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//   const charactersLength = characters.length;
//   let counter = 0;
//   while (counter < length) {
//     result += characters.charAt(Math.floor(Math.random() * charactersLength));
//     counter += 1;
//   }
//   return result;
// }

export const findPrime = (num) => {
  let i,
    primes = [2, 3],
    n = 5;
  const isPrime = (n) => {
    let i = 1,
      p = primes[i],
      limit = Math.ceil(Math.sqrt(n));
    while (p <= limit) {
      if (n % p === 0) {
        return false;
      }
      i += 1;
      p = primes[i];
    }
    return true;
  };
  for (i = 2; i <= num; i += 1) {
    while (!isPrime(n)) {
      n += 2;
    }
    primes.push(n);
    n += 2;
  }
  return primes[num - 1];
};

export function formatNumber(num) {
  if (num >= 1e9) return (num / 1e9).toFixed(1) + 'B';
  if (num >= 1e6) return (num / 1e6).toFixed(1) + 'M';
  if (num >= 1e3) return (num / 1e3).toFixed(1) + 'K';
  return num.toString();
};
